export type BillingsTaxiTaxiEditParamsNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date;
  checkoutEventUuid: string | null;
  plannedDate: Date;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiTaxiEditParamsContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiTaxiEditParamsContributionBonusFavorableDistance = {
  type: BillingsTaxiTaxiEditParamsContributionType.BONUS_FAVORABLE_DISTANCE;
  comment: string | null;
  distance: number;
  rate: number;
};

export type BillingsTaxiTaxiEditParamsContributionBonusOther = {
  type: BillingsTaxiTaxiEditParamsContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditParamsContributionPenaltyWrongRoute = {
  type: BillingsTaxiTaxiEditParamsContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditParamsContributionPenaltyBeingLate = {
  type: BillingsTaxiTaxiEditParamsContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditParamsContributionPenaltyIncompatibleCar = {
  type: BillingsTaxiTaxiEditParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditParamsContributionPenaltyOther = {
  type: BillingsTaxiTaxiEditParamsContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiEditParamsContributionBonus =
  | BillingsTaxiTaxiEditParamsContributionBonusFavorableDistance
  | BillingsTaxiTaxiEditParamsContributionBonusOther;

export type BillingsTaxiTaxiEditParamsContributionPenalty =
  | BillingsTaxiTaxiEditParamsContributionPenaltyWrongRoute
  | BillingsTaxiTaxiEditParamsContributionPenaltyBeingLate
  | BillingsTaxiTaxiEditParamsContributionPenaltyIncompatibleCar
  | BillingsTaxiTaxiEditParamsContributionPenaltyOther;

export type BillingsTaxiTaxiEditParamsContribution =
  | BillingsTaxiTaxiEditParamsContributionBonus
  | BillingsTaxiTaxiEditParamsContributionPenalty;

type BillingsTaxiTaxiEditParams = {
  billingUuid: string;
  billingNodes: BillingsTaxiTaxiEditParamsNode[];
  billingContributions: BillingsTaxiTaxiEditParamsContribution[];
};

export default BillingsTaxiTaxiEditParams;
